import './App.css';
import Routers from './components/Routers/Routes';

function App() {
  return (
    <Routers />
  );
}

export default App;
